function isUndefined(arg) {
    return arg === void 0;
}

function isNullOrUndefined(arg) {
    return arg == null;
}
